import { CheckIcon } from '@heroicons/react/24/solid'
import { useShallow } from 'zustand/react/shallow'

import { useExporterNodeStore } from '@ui/stores'

const steps = [
  { name: 'Destination', href: '#' },
  { name: 'Configure', href: '#' },
]

export function Wizard() {
  const wizardStep = useExporterNodeStore(useShallow((state) => state.wizardStep))
  const setWizardStep = useExporterNodeStore(useShallow((state) => state.setWizardStep))
  const setTemplate = useExporterNodeStore(useShallow((state) => state.setTemplate))

  const goBackClick = (newStep: number) => {
    setWizardStep(newStep)
    if (newStep === 0) {
      setTemplate(null)
    }
  }

  return (
    <nav aria-label="Progress" className="flex w-full justify-between rounded-t-md border-b bg-white">
      <ol role="list" className="flex">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className="relative flex w-52 flex-1">
            {stepIdx < wizardStep ? (
              <a href={step.href} className="group flex w-full items-center">
                <span className="flex items-center px-6 py-2 text-sm font-medium">
                  <span
                    className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-600 group-hover:bg-primary-800"
                    onClick={() => goBackClick(stepIdx)}>
                    <CheckIcon className="size-6 text-white" aria-hidden="true" />
                  </span>
                  <span className="ml-4 text-sm font-medium text-gray-900" onClick={() => goBackClick(stepIdx)}>
                    {step.name}
                  </span>
                </span>
              </a>
            ) : stepIdx === wizardStep ? (
              <a href={step.href} className="flex items-center px-6 py-2 text-sm font-medium" aria-current="step">
                <span className="flex size-8 shrink-0 items-center justify-center rounded-full border-2 border-primary-600">
                  <span className="text-primary-600">{stepIdx + 1}</span>
                </span>
                <span className="ml-4 text-sm font-medium text-primary-600">{step.name}</span>
              </a>
            ) : (
              <a href={step.href} className="group flex items-center">
                <span className="flex items-center px-6 py-2 text-sm font-medium">
                  <span className="flex size-8 shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-primary-400">
                    <span className="text-gray-500 group-hover:text-gray-900">{stepIdx + 1}</span>
                  </span>
                  <span className="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">{step.name}</span>
                </span>
              </a>
            )}

            {stepIdx !== steps.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div className="absolute right-0 top-0 hidden h-full w-5 md:block" aria-hidden="true">
                  <svg className="size-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                    <path
                      d="M0 -2L20 40L0 82"
                      vectorEffect="non-scaling-stroke"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  )
}
